function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as roomsActions from './../roomsActions';
import { leaveRoom } from './../../Chatroom/chatroomActions';

export var ChatroomSelector = function (_Component) {
    _inherits(ChatroomSelector, _Component);

    function ChatroomSelector() {
        var _temp, _this, _ret;

        _classCallCheck(this, ChatroomSelector);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.leaveChatroom = function (dispatch) {
            return new Promise(function (resolve, reject) {
                dispatch(leaveRoom());
                resolve();
            });
        }, _this.handleSubmit = function (e) {
            e.preventDefault();
            var dispatch = _this.props.dispatch;


            var roomId = e.target.room.value;
            var roomName = e.target.roomName.value;

            _this.leaveChatroom(dispatch).then(function () {
                dispatch(roomsActions.selectRoom(roomId, roomName));
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ChatroomSelector.prototype.render = function render() {
        var _props = this.props,
            chatroomName = _props.chatroomName,
            room = _props.room,
            reportUnview = _props.reportUnview,
            isInProgress = _props.isInProgress,
            inUseChatroom = _props.inUseChatroom;

        return React.createElement(
            'form',
            { className: 'input', onSubmit: this.handleSubmit },
            React.createElement('input', { type: 'hidden',
                name: 'room',
                value: room }),
            React.createElement('input', { type: 'hidden',
                name: 'roomName',
                value: chatroomName }),
            React.createElement('input', { type: 'submit', value: chatroomName, disabled: isInProgress, className: inUseChatroom === room ? 'inUse' : reportUnview ? 'report' : '' })
        );
    };

    return ChatroomSelector;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
    var isInProgress = state.rooms.isInProgress;

    return {
        isInProgress: isInProgress,
        inUseChatroom: state.chatroom.chatroomId
    };
};

export default connect(mapStateToProps)(ChatroomSelector);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Rooms/ChatroomSelector/ChatroomSelector.js
// module id = 228
// module chunks = 0